import { render } from "./CommonRecipeFoodIds.vue?vue&type=template&id=8cbae900&ts=true"
import script from "./CommonRecipeFoodIds.vue?vue&type=script&lang=ts"
export * from "./CommonRecipeFoodIds.vue?vue&type=script&lang=ts"

import "./CommonRecipeFoodIds.vue?vue&type=style&index=0&id=8cbae900&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__